import {Loc} from 'src/common/map/Location';
import {Texture, Sprite, Point} from 'pixi.js';
import GameModel from 'src/game/GameModel';
import {PointerMoveAction} from 'src/Action';
import {markerTintForPlayerIndex} from './player-colors';
import GameUtils from 'src/game/GameUtils';
import {Pointer} from './Pointer';

type PointerType = 'pointer' | 'target';

interface TextureSpec {
    texture: Texture;
    anchor: Point;
}

export class PointerRenderer {
    private textures: {pointer: TextureSpec; target: TextureSpec};
    private pointers: Map<number, Pointer>;

    public setup(): void {
        this.pointers = new Map<number, Pointer>();
        this.textures = {
            pointer: {
                texture: GameUtils.spriteTexture('cursors/pointer'),
                anchor: new Point(1, 0),
            },
            target: {
                texture: GameUtils.spriteTexture('cursors/target'),
                anchor: new Point(0.5, 0.5),
            },
        };
    }

    public setPointerType(type: PointerType): void {
        this.pointers.forEach(pointer => {
            const {texture, anchor} = this.textures[type];
            pointer.sprite.texture = texture;
            pointer.sprite.anchor.set(anchor.x, anchor.y);
        });
    }

    public tick(): void {
        this.pointers.forEach(pointer => pointer.tick());
    }

    public createOrUpdatePointer(action: PointerMoveAction): void {
        let pointer = this.pointers.get(action.owner);
        if (pointer) {
            pointer.setAction(action);
        } else {
            pointer = new Pointer(this.createPointer(action.owner, {x: 0, y: 0}), action);
            this.pointers.set(action.owner, pointer);
        }
    }

    public hidePointer(index: number): void {
        const pointer = this.pointers.get(index);
        if (pointer) {
            pointer.sprite.visible = false;
        }
    }

    private createPointer(index: number, {x, y}: Loc): Sprite {
        const tint = markerTintForPlayerIndex(index);
        const sprite = GameUtils.makeSprite(`cursors/pointer`, x, y, 0.5, tint);
        GameModel.cursorContainer.addChild(sprite);
        return sprite;
    }
}

export const pointerRenderer = new PointerRenderer();



// WEBPACK FOOTER //
// ./src/Pixi/PointerRenderer.ts